import React from "react";
import  { useState, useEffect } from 'react';
import './classes/ScoutsMap.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";


const ScoutsMap = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);
    const [scoutSports, setScoutSports] = useState([]);

    useEffect(() => {
        Promise.all([
            // getambassadorlist()
            
            
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);


    useEffect(() => {
        const staticData = [
            {   
                id: "1", 
                name: 'Baseball',
                image: '/basic/web/images/scout/scoutmap-11.jpg',
                url:'/scout-sports/baseball',
            },
            {   
                id: "2", 
                name: 'Basketball',
                image: '/basic/web/images/scout/scoutmap-22.jpg',
                url:'/scout-sports/basketball',
            },
            {   
                id: "3", 
                name: 'Cricket',
                image: '/basic/web/images/scout/scoutmap-33.jpg',
                url:'/scout-sports/cricket',
            },
            {   
                id: "4", 
                name: 'Football',
                image: '/basic/web/images/scout/scoutmap-44.jpg',
                url:'/scout-sports/football',
            },
            {   
                id: "5", 
                name: 'Hockey',
                image: '/basic/web/images/scout/scoutmap-55.jpg',
                url:'/scout-sports/hockey',
            },
            {   
                id: "6", 
                name: 'Soccer',
                image: '/basic/web/images/scout/scoutmap-66.jpg',
                url:'/scout-sports/soccer',
            },
            {   
                id: "7", 
                name: 'Rugby',
                image: '/basic/web/images/scout/scoutmap-77.jpg',
                url:'/scout-sports/rugby',
            },
        ];
        setScoutSports(staticData);
    },[]);

    const firstHalf = scoutSports.slice(0, 4); 
    const secondHalf = scoutSports.slice(4); 

    const handleClick = (continent) => {
        navigate('/continents/'+continent+'/scouts');
    };

    const handleUSClick = () => {
        navigate('/sports_scouts_usmap');
    };

    const handleCanadaClick = () => {
        navigate('/sports-scout-canada-map');
    };
     
    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main" className="scoutsmap-main">
                <Helmet><title>Scouts Map</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                    <div className="scoutsmap-container">
                    <h1>Scouts Map</h1>
                    <p>Sports Management Worldwide is proud to have scouts located all over the world. 
                        If you are looking for a scouting report, you can <a href="/scouting-requests">request one here</a>.</p>
                    <p>To view our rapidly expanding network of scouts around the world, click on a continent below. To simply see a listing of all scouts, <a href="/scouts">click here</a>.</p>
                    <div>&nbsp;</div>
                    <h3>To see a list of scouts by individual sport:</h3>
                    <div>&nbsp;</div>
                    <div className="imgboxxe">
                        {firstHalf.map((scoutSport, index) => (
                            <span key={index}>
                                <a href={scoutSport.url}><img src={scoutSport.image} alt={scoutSport.name} /></a>
                            </span>
                        ))}
                    </div>
                    <div className="imgboe">
                        {secondHalf.map((scoutSport, index) => (
                            <span key={index}>
                                <a href={scoutSport.url}><img src={scoutSport.image} alt={scoutSport.name} /></a>
                            </span>
                        ))}
                    </div>
                    <div style={{clear: "both"}}>&nbsp;</div>
                        <div style={{margin: "auto", textAlign: "center"}}>
                            <div className="mobilemaparea">
                            <h1><a 
                            // href="/sports-scout-canada-map"
                            onClick={(e) => {e.preventDefault(); handleCanadaClick();}}
                            >Scouts in Canada</a></h1>

                            <h1><a 
                            // href="/continents/1/scouts"
                            onClick={(e) => {e.preventDefault(); handleClick('1');}}
                            >Scouts in Mexico &amp; Central America</a></h1>

                            <h1><a 
                            // href="/sports_scouts_usmap"
                            onClick={(e) => {e.preventDefault(); handleUSClick();}}
                            >Scouts in USA</a></h1>

                            <h1><a 
                            // href="/continents/2/scouts"
                            onClick={(e) => {e.preventDefault(); handleClick('2');}}
                            >Scouts in South America</a></h1>

                            <h1><a 
                            // href="/continents/3/scouts"
                            onClick={(e) => {e.preventDefault(); handleClick('3');}}
                            >Scouts in Europe</a></h1>

                            <h1><a 
                            // href="/continents/4/scouts"
                            onClick={(e) => {e.preventDefault(); handleClick('4');}}
                            >Scouts in Asia &amp; Middle East</a></h1>

                            <h1><a 
                            // href="/continents/5/scouts"
                            onClick={(e) => {e.preventDefault(); handleClick('5');}}
                            >Scouts in Africa</a></h1>

                            <h1><a 
                            // href="/continents/6/scouts"
                            onClick={(e) => {e.preventDefault(); handleClick('6');}}
                            >Scouts in South Pacific</a></h1>
                            </div>
                            <div className="webmaparea">
                                <img
                                    src="/basic/web/images/scout/agencyhome-maps2.jpg"
                                    alt="World Map"
                                    useMap="#Mapu"
                                    style={{
                                        width: '100%',
                                        maxWidth: '650px',
                                        height: 'auto'
                                    }}
                                />
                                <map name="Mapu" id="Mapu">
                                    <area 
                                        coords="4,31,68,90" 
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleUSClick();}}
                                        // href="/sports_scouts_usmap"
                                    />
                                    <area 
                                        coords="71,91,216,115" 
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleUSClick();}}
                                        // href="/sports_scouts_usmap"
                                    />
                                    <area 
                                        coords="65,8,295,91"
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleCanadaClick();}}
                                        // href="/sports-scout-canada-map"
                                    />
                                    <area 
                                        coords="78,113,214,153" 
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleClick('1');}}
                                    />
                                    <area 
                                        coords="154,153,263,282"
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleClick('2');}}
                                    />
                                    <area 
                                        coords="307,12,440,98" 
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleClick('3');}}
                                    />
                                    <area 
                                        coords="440,9,642,186"
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleClick('4');}}
                                    />
                                    <area 
                                        coords="911,330,1051,440"
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleClick('6');}}
                                    />
                                    <area 
                                        coords="539,187,633,265"
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleClick('6');}}
                                    />
                                    <area 
                                        coords="289,101,404,254" 
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleClick('5');}}
                                    />
                                    <area 
                                        coords="395,89,446,146"  
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleClick('4');}}
                                    />
                                </map>
                            </div>
                        </div>
                        <p>&nbsp;</p>
                        <div style={{clear: "both", textAlign: "center", marginBottom: "10px"}}>
                            <a className="reddbtnn" href="/application">Scouts Needed - Apply here</a>
                        </div>
                        <p>&nbsp;</p>
                        </div>
                </div>
                <div className="right">
                      {/* {
                        (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                        userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                        userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))
                            &&  */}
                            <SalespersonSidebar /> 
                        {/* }  */}
                </div>
            </div>
        )}
        </>
    );
};
export default ScoutsMap;